import {
  List,
  ListItem,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import InsertForm from "./InsertForm";
import { useState } from "react";

function WordsPreview({ title, words, onDelete, onAdd, user_id }) {
  const [formOn, setFormOn] = useState(false);

  const formOnHandler = (value) => {
    setFormOn(value);
  };

  const submitionHandler = (word) => {
    const trimmedWord = word.trim();
    console.log(`Saving new word '${trimmedWord}'`);

    onAdd(trimmedWord, user_id);
    setFormOn(false);
  };

  let component = <p>No words</p>;
  if (words) {
    component = (
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {words.map((word, index) => (
          <ListItem
            key={index}
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => onDelete(word.id)}
              >
                <DeleteOutline fontSize="small" color="disabled" />
              </IconButton>
            }
          >
            {word.name} {word.count}
          </ListItem>
        ))}
      </List>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="h3" gutterBottom>
          {title}
        </Typography>

        {formOn ? (
          <InsertForm
            onSubmitted={submitionHandler}
            onCancel={() => formOnHandler(false)}
          />
        ) : (
          <Button
            onClick={() => formOnHandler(true)}
            size="small"
            variant="text"
          >
            Add
          </Button>
        )}

        {component}
      </CardContent>
    </Card>
  );
}

export default WordsPreview;
